import { getEnv } from "./env";

export const isValidUrl = (string: string): boolean => {
  try {
    new URL(string);
    return string.startsWith(getEnv().NEXT_PUBLIC_CLIENT_SIDE_API_URL);
  } catch (_err) {
    return false;
  }
};

export const mapDropdownFilterValuesToJSONPath = (
  cruiseIds: string[],
  rovLoweringIds: string[]
): string | null => {
  if (cruiseIds.length === 0 && rovLoweringIds.length === 0) {
    return null;
  }

  const cruisePredicates = cruiseIds
    .map((id) => `@.cruise_external_id == "${id}"`)
    .join(" || ");

  const rovLoweringPredicates = rovLoweringIds
    .map((id) => `@.deployment_external_id == "${id}"`)
    .join(" || ");

  const joinedJSONPath = [cruisePredicates, rovLoweringPredicates]
    .filter((a) => a)
    .join(" || ");

  return `$[*] ? (${joinedJSONPath})`;
};

export const CLASSIFICATION_THRESHOLD = 0.6;
